/**
 * Generated by orval 🍺
 * Do not edit manually.
 * GTA CRM Demo API
 * GTA CRM 生产级 demo 的只读+轻写 API(feat-008;demo-scoped,零 model 零迁移)。
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `direct_message` - 私信
 * * `comment` - 评论
 */
export type ContactKindEnum =
  (typeof ContactKindEnum)[keyof typeof ContactKindEnum];

export const ContactKindEnum = {
  direct_message: "direct_message",
  comment: "comment",
} as const;
